import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./user"; // Make sure this import is correct
import { userDataSlice } from "./views/pages/Users/store/userDataSlice";
import { employeeSlice } from "./views/pages/Employee/store/employeeSlice";
import { attendanceSlice } from "./views/pages/Attendance/store/attendanceSlice";
import { payrollSlice } from "./views/pages/Payroll/store/PayrollDataSlice";
import { tdsSlice } from "./views/pages/TDS/store/tdsSlice";
import { arrearsSlice } from "./views/pages/Arrears/store/arrearsSlice";
import { incentiveSlice } from "./views/pages/Incentive/store/incentiveSlice";
import { penaltySlice } from "./views/pages/Penalty/store/penaltySlice";
import { employeerComponentSlice } from "./views/pages/EmployeerComponent/store/employeerComponentSlice";
import { trackSheetSlice } from "./views/pages/TrackSheet/store/trackSheetSlice";
import { reimbursementSlice } from "./views/pages/Reimbursement/store/reimbursementSlice";
import { employeeBankDetailSlice } from "./views/pages/EmployeeBankDetails/store/employeeBankDetailsSlice";
import { bonusSlice } from "./views/pages/Bonus/store/bonusSlice";
import { earnedLeaveSlice } from "./views/pages/EarnedLeave/store/earnedLeaveSlice";
import { reportSlice } from "./views/pages/Report/store/ReportDataSlice";

const reducer = {
  user: userSlice.reducer,
  userData: userDataSlice.reducer,
  employeeData: employeeSlice.reducer,
  attendanceData: attendanceSlice.reducer,
  payrollData: payrollSlice.reducer,
  tdsData: tdsSlice.reducer,
  arrearsData: arrearsSlice.reducer,
  incentiveData: incentiveSlice.reducer,
  penaltyData: penaltySlice.reducer,
  employeerComponentData: employeerComponentSlice.reducer,
  trackSheetData: trackSheetSlice.reducer,
  reimbursementData: reimbursementSlice.reducer,
  employeeBankDetailData: employeeBankDetailSlice.reducer,
  bonusData: bonusSlice.reducer,
  earnedLeaveData: earnedLeaveSlice.reducer,
  reportData: reportSlice.reducer
};

const store = configureStore({
  reducer: reducer,
  devTools: true,
});

export default store;
